// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2685":"68e515f3","3603":"06d75036","4891":"01764bcb","5051":"089a573a","6470":"87abef67","9805":"db386898"}[chunkId] + ".chunk.css";
};